import { render } from "./Earthquake.vue?vue&type=template&id=2f212848"
import script from "./Earthquake.vue?vue&type=script&lang=js"
export * from "./Earthquake.vue?vue&type=script&lang=js"

import "./Earthquake.vue?vue&type=style&index=0&id=2f212848&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__